"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function Concat({
  list
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, list.map(item => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: `react-frag-${Math.round(Math.random() * 10000000)}`
    }, typeof item === 'string' && item !== '' ? (0, _htmlReactParser.default)(item) : item);
  }));
}
var _default = exports.default = Concat;